import { render } from "./ConfirmationAccount.vue?vue&type=template&id=560e624a&scoped=true"
import script from "./ConfirmationAccount.vue?vue&type=script&lang=js"
export * from "./ConfirmationAccount.vue?vue&type=script&lang=js"

import "./ConfirmationAccount.vue?vue&type=style&index=0&id=560e624a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560e624a"]])

export default __exports__